import { useMutation } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { UpdateFinanceAccountRequestDTO } from "@/types";
import { RequestFinanceAccountResponse } from "@/types";
import { useQueryClient } from "@tanstack/react-query";

async function updateFinanceAccount(
  request: UpdateFinanceAccountRequestDTO
): Promise<RequestFinanceAccountResponse> {
  const { id, ...data } = request;
  const response = await httpRequest.put<RequestFinanceAccountResponse>(
    `/finance-accounts/${id}`,
    data
  );
  return response.data;
}

export function useUpdateFinanceAccountMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateFinanceAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accounts"] });
    },
  });
}
